module.exports = __webpack_public_path__ + "img/6001001000.e12d806.webp";